"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ImageSlot = void 0;
var _react = _interopRequireDefault(require("react"));
var _coreBaseProps = require("@vfuk/core-base-props");
var _coreImage = _interopRequireDefault(require("@vfuk/core-image"));
var _SlotWrapper = _interopRequireDefault(require("../../SlotWrapper"));
var _excluded = ["slotWrapper", "dataSelectorPrefix"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ImageSlot = function ImageSlot(_ref) {
  var slotWrapper = _ref.slotWrapper,
    dataSelectorPrefix = _ref.dataSelectorPrefix,
    image = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_SlotWrapper["default"], _extends({
    fullWidth: (slotWrapper === null || slotWrapper === void 0 ? void 0 : slotWrapper.fullWidth) || true,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix)
  }, slotWrapper), /*#__PURE__*/_react["default"].createElement(_coreImage["default"], _extends({}, image, {
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'image')
  })));
};
exports.ImageSlot = ImageSlot;
ImageSlot.displayName = "ImageSlot";
var _default = ImageSlot;
exports["default"] = _default;
//# sourceMappingURL=ImageSlot.js.map